/**
 * Tab-local "SPA session was established" latch for cookie-mode admin auth.
 *
 * Cookie mode keeps memory Bearer null; when the access httpOnly cookie expires,
 * APIs return `No token provided`. Anonymous cold-boot must still skip refresh
 * thrash, but an established SPA session must attempt cookie rotate (and logout
 * if the refresh cookie is gone).
 *
 * AuthProvider marks this when `user != null` and clears on session wipe.
 */

let sessionHydrated = false;

export function markAdminSessionHydrated(): void {
  sessionHydrated = true;
}

export function clearAdminSessionHydrated(): void {
  sessionHydrated = false;
}

export function isAdminSessionHydrated(): boolean {
  return sessionHydrated;
}

/** Test-only reset. */
export function resetAdminSessionHydratedLatchForTests(): void {
  sessionHydrated = false;
}
